import React , { useEffect } from 'react'
import { useAuthService } from "../../services";
import { useSearchParams } from "react-router-dom";
import { ApiUrl, NotifyType } from "../../util/app-config";
import { notify } from "../../util";

function SingpassLogin() {
  const { createSession, initSingpassAuth } = useAuthService();
  let [searchParam, setSearchPara] = useSearchParams();
  const { message } = notify();

  useEffect(() => {
    const handleNavigate = async () => {
      const session = await createSession(searchParam.get("ut"), searchParam.get("lt"));
      if (!session || !session.state || !session.nonce) {
        message(NotifyType.Error, "Unable to create Singpass login session");
        return;
      }

      const initAuthResponse = await initSingpassAuth({
        state: session.state,
        nonce: session.nonce
      }, ApiUrl.SPInitAuth);

      if (initAuthResponse && initAuthResponse.authorizationUrl) {
        window.location.href = initAuthResponse.authorizationUrl;
      } else {
        message(NotifyType.Error, "Unable to initialize Singpass authorization");
      }
    }
    handleNavigate();
  }, []);

  return (
    <div>Redirecting to Singapss..........</div>
  )
}

export default SingpassLogin
